import React from "react";
import Home from "./Components/Main/Home";


function App() {
  return(
    <>
    <Home />
    </>
  )
}

export default App;